import { isEqual, sortBy } from "lodash";

import { Stem, StemAssociate } from "@examspark/types";

import { getNewScore } from ".";

export const scoreAssociate = (
  expected: StemAssociate,
  actual: Stem.Response,
) => {
  const score = getNewScore();
  const { scoring, config } = expected;

  if (!actual?.pairs) {
    return score;
  }

  const keyPairs: Array<Array<string>> = [];
  scoring?.pairs?.forEach((p) => {
    if (p.isKey) {
      keyPairs.push(sortBy([p.src!, p.dst!]));
    }
  });

  const actualPairs: Array<Array<string>> = [];
  actual.pairs.forEach((p: any) => {
    actualPairs.push(sortBy([p.src, p.dst]));
  });

  // Exact Scoring:
  console.log("score these pairs:", sortBy(keyPairs), sortBy(actualPairs));
  if (isEqual(sortBy(keyPairs), sortBy(actualPairs))) {
    score.max = 1;
    score.actual = 1;
  }

  score.max = 1;
  return score;
};
